<template>
  <div class="container">
    <div class="banner"
         ref="banner"></div>
    <div class="tab"
         :class="isTabFixed?'tabFixed':''">
      <div class="tab-item"
           v-for="(item,index) in tabList"
           :key="index"
           @click="tabItemClick(index)">
        <div class="item-text">
          <span class="tab-name"
                :class="stateIndex== index?'tabNameActive':''">{{item.name}}</span>
        </div>
        <!-- <div class="line"
             :class="stateIndex== index?'tabLine-ed':'tabLine-df'"></div> -->
      </div>
    </div>
    <div :class="isTabFixed?'containerMtop':''">
      <tabOne v-if="stateIndex== 0"></tabOne>
      <tabTwo v-if="stateIndex== 2"></tabTwo>
      <tabThree v-if="stateIndex== 1"></tabThree>
    </div>
    <!-- <div class="intro">
      <div style="text-align: center;">
        <img src="../../assets/images/about-us/logo.png"
             alt=""
             class="intro-img">
      </div>
      <p class="intro-text">
        广州翼然科技股份有限公司（简称“翼然科技”，英文简称“YIRAN TECH”）【股权代码：880178】注册成立于二零一四年，座落于国家级软件产业基地广州海珠创意园；是一家集数据、软件、服务于一体的中国领先的全域智慧旅游产业服务商。公司专注于“全域智慧旅游”文旅业态融合服务平台应用开发及运营、互联网＋智慧景区、文旅融合大数据应用、一部手机游APP/小程序/公众号、旅游大数据平台、3D智能导游系统、电子售检票系统/商城分销系统、电子触摸屏系统、车辆实时调度系统、游客集散中心/游客服务中心/旅游驿站/全息投影科普展厅、全域全景旅游导览地图绘制、AI/VR/人工智能技术应用及配套运营服务等；并向客户提供从数据采集、软件开发、系统集成、内容策划制作、项目实施，到后期维护保障的全方位服务和一体化智慧旅游/全域旅游文化云整体解决方案。 公司旗下【翼旅游®】品牌，主要服务于“全域智慧旅游”信息化建设，其中“互联网＋3D智能导游云服务系统平台及一部手机游小程序/APP服务平台”是以“互联网+智慧旅游”为核心理念研发而成的文旅云服务平台。以实时在线语音讲解、3D导览和精准营销服务为切入点，服务于游前、游中、游后的智能导游/导航/导览/导购、GPS实时定位、自动规划线路、精准营销、周边商家优惠劵推送、活动提醒、特产商城、语音主播、POI热点搜索、旅游新媒体、游记攻略、票务预订等功能为一体的智慧旅游共享开放服务平台。目前是国内在该领域技术最为成熟的3D智能导览数据提供商，获得了多家国内知名的投资机构的青睐。 近年来，公司以其先进的技术，专业的服务，卓越的品质为近百家政府及企事业单位提供技术服务。并与中山大学、武汉大学、广东财经大学、桂林旅游学院和广西旅游科学研究所在人才和技术方面建立了良好的合作关系，为公司致力于智慧旅游产业建设服务提供了强大的支持。
      </p>
    </div> -->
    <!-- <div class="about-us">
      <Title activeColor='#293333'
             activeText='联系我们'></Title>
      <div class="about-us-info">
        <div class="info-text">
          <p>电话：020-37209386</p>
          <p>传真：020-37209386</p>
          <p>邮箱：elvyoo@elvyoo.com</p>
          <p>地址：广州市海珠区新港东路238号海珠创意园F1栋5楼</p>
          <div class="info-code">
            <div>
              <img src="../../assets/images/about-us/man1.png"
                   alt=""
                   class="about-img-size">
              <p class="text-center">骆经理</p>
              <p class="text-center">13928799037</p>
            </div>
            <div class="margin-left-40">
              <img src="../../assets/images/about-us/man2.png"
                   alt=""
                   class="about-img-size">
              <p class="text-center">刘经理</p>
              <p class="text-center">13926477660</p>
            </div>
          </div>
        </div>
        <div>
          <img src="../../assets/images/about-us/map.png"
               alt=""
               class="map-size">
        </div>
      </div>
    </div> -->
    <!-- tab切换 -->

  </div>
</template>
<script>
// import Title from '../../components/title';
import tabOne from './tab_1';
import tabTwo from './tab_2';
import tabThree from './tab_3';
export default {
  components: {
    tabOne,
    tabTwo,
    tabThree
  },
  data () {
    return {
      isTabFixed: false,
      stateIndex: 0,
      codeIndex: -1,
      scrollYHeight: 0,
      H: 0,
      tabList: [{
        name: '公司简介'
      }, {
        name: '资质证书'
      }, {
        name: '联系我们'
      }],
    }
  },
  mounted () {
    this.caseList = this.caseList1
    window.addEventListener('scroll', this.handleScroll);
    this.scrollYHeight = this.$refs.banner.offsetHeight;

  },
  methods: {
    handleScroll () {
      let scrollY = window.scrollY;
      // console.log(scrollY)
      let H = Number(this.scrollYHeight) + 100
      // console.log(H, 'h')
      this.H = H
      if (scrollY >= H) {
        this.isTabFixed = true
      } else {
        this.isTabFixed = false
      }
    },
    tabItemClick (index) {
      this.stateIndex = index
      if (this.stateIndex == 0) {
        this.caseList = this.caseList1
      } else if (this.stateIndex == 1) {
        this.caseList = this.caseList2
      } else {
        this.caseList = this.caseList3
      }
      window.scroll(0, this.H)
    },
  }
}
</script>
<style  scoped>
.container {
  background: #f5f5f5;
  height: 100%;
}
.banner {
  position: relative;
  background: url("../../assets/images/about-us/banner.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: 4rem;
  width: 19.2rem;
}
.intro {
  background: #ffffff;
  padding: 0.8rem 0;
}
.intro-img {
  width: 6.27rem;
}
.intro-text {
  width: 12rem;
  margin: 0.8rem auto 0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0.32rem;
  color: #4d4d4d;
  text-indent: 0.33rem;
}
.about-us {
  padding: 1.2rem 0;
}
.about-us-info {
  width: 12rem;
  margin: 0.8rem auto 0;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  padding: 0.6rem;
  box-sizing: border-box;
}
.info-text {
  font-size: 0.16rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0.32rem;
  color: #4d4d4d;
}
.info-code {
  line-height: 0.24rem;
  margin-top: 0.5rem;
}
.about-img-size {
  width: 1.8rem;
  height: 1.8rem;
}
.info-code {
  display: flex;
}
.text-center {
  text-align: center;
}
.margin-left-40 {
  margin-left: 0.4rem;
}
.map-size {
  width: 6.4rem;
  height: 4.8rem;
}

.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 19.2rem;
  height: 0.8rem;
  line-height: 0.8rem;

  /* background: #f5f5f5; */
}
.tab-img {
  width: 0.32rem;
  height: 0.32rem;
}
.tab-item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  /* position: relative;
  top: 8px; */
}
.item-text {
  display: flex;
  justify-content: center;
}
.tab-item:nth-child(2) {
  margin: 0 2.5rem;
}
.tab-name {
  font-size: 0.24rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 0.3rem;
  color: #4d4d4d;
  margin-left: 2px;
}
.line {
  width: 1.4rem;
  height: 4px;
  margin-top: 0.1rem;
  background: #5cd4ca;
}
.tabNameActive {
  color: #5cd4ca;
}
.tabLine-ed {
  background: #5cd4ca;
}
.tabLine-df {
  background: #f5f5f5;
}
.tabFixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 19.2rem;
  height: 0.8rem;
  line-height: 0.8rem;
  background: #f5f5f5;
  border-bottom: 1px solid #ccc;
}
.case-list-title {
  display: inline-block;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 0.1rem 0.25rem;
  font-size: 0.3rem;
  color: #ffffff;
  margin-top: 0.3rem;
  box-sizing: border-box;
}
.containerMtop {
  /* margin-top: 100px !important; */
}
</style>